import React, { useEffect, useState } from "react";
import {getCartItems, getCartInfo, order, queue, orderV2, GetLinkInfor } from "../../../service/cartService";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import { toast } from "react-toastify";
import { isAuth } from "../../../helpers/general";
import { useLocation } from "@reach/router";

import './css/cart.css';
const Completeorder = () => {
       const location = useLocation();
    if (isAuth === false) {
        window.location.href = '/';
    }
    const [msg, setMsg] = useState('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!');
    const [msgBd, setMsgBd] = useState('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!');
    const [idcart, setIdcart] = useState('');
    const [id, setId] = useState('');
    const [idOrder, setIdOrder]= useState('');
    const loadComplateCart=()=>{
        try {
            orderV2(null, window.localStorage.getItem('key')).then((response) => {
                if (response.status === 200) {
                    setIdcart(response['message'].code);
                    setId(response['message']._id);
                    setIdOrder(response['message']._id);
                    queue(response['message']._id, window.localStorage.getItem('key')).then((response1) => {
                        if (response1.status === 200) {
                            setIdcart(response1['message'].sale);
                            setId(response1['message']._id);
                            localStorage.removeItem("itemsCart");
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                            return;
                        }
                        if (response1['message'].status_queue === 0 || response1['message'].status_queue === 1) {
                            setMsg('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ giây lát!');
                            setMsgBd('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ trong giây lát');
                        } 
                        if (response1['message'].status_queue === 2 || response1['message'].status_queue === 4 || response1['message'].status_queue === 5) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng đặt không thành công! Rất xin lỗi vì sự bất tiện này, Bạn vui lòng đặt lại đơn hàng');
                        }  
                        if (response1['message'].status_queue === 3) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                        }
                    });
                }
                if (response.status === 202) {
                    setIdcart(response['message'].code);
                    setId(response['message']._id);
                    setIdOrder(response['message']._id);
                    localStorage.removeItem("itemsCart");
                    setMsg('Đơn hàng đang chờ thanh toán');
                    setMsgBd('Bạn có đơn hàng đang chờ thanh toán. Xin vui lòng thanh toán');
                    // window.open(
                    //     response.message.urlPayment,
                    //     '_blank' 
                    //   );
                    window.location.href = response.message.urlPayment;
                }
                setTimeout(() => {
                    getCartInfo(window.localStorage.getItem('key')).then((response) => {
                        window.localStorage.setItem('cartInfo', JSON.stringify(response['message']));
    
                        let _cartInfo = response['message'];
                        if (_cartInfo !== null) {
                            window.localStorage.setItem('bixu', _cartInfo[0]?.owner?.bixu);
                        }
                    }, 1000);
    
                    
                }, 1000);
            });
            
        } catch (e) {
            console.log(e);
        }
    }
    const [fixMsg, setFixMsg] = useState('');
    useEffect(()=>{
        const params = Object.fromEntries(new URLSearchParams(location.search.substring(1)));
        if(params && Object.keys(params).length>0){
            setFixMsg(params.des);
            setIdcart(params['code']);
            setId(params['id']);
            setIdOrder(params['id']);
            setMsg(params['title']);
            setMsgBd(params['des']);
        }else{
            loadComplateCart();
            getCartItems(window.localStorage.getItem('key')).then((response) => {
                localStorage.setItem('itemsCart', JSON.stringify(response['message']));
            });
            var perc = JSON.parse(window.localStorage.getItem('layoutGA'));
            if(perc){
                let date = new Date();
                let result = date.getTime();
                perc.ecommerce['transaction_id']=result;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(perc);
                window.localStorage.removeItem("layoutGA");
            }
        }
    },[])

    const [isSuccess, setIsSucces] = useState(false);
    useEffect(() => {
        const params = Object.fromEntries(new URLSearchParams(location.search.substring(1)));
        setIsSucces(params.success);
        if(Object.keys(params).length === 0){
            const Interval = setInterval(() => {
                    queue(idOrder, localStorage.getItem('key')).then((response1) => {
                        if (response1.status === 200) {
                            setIdcart(response1['message'].sale);
                            setId(response1['message']._id);
                            localStorage.removeItem("itemsCart");
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                            setTimeout(async () =>{
                                await getCartInfo(localStorage.getItem('key')).then((response)=>{
                                window.localStorage.setItem('cartInfo', JSON.stringify(response['message']));
                                
                                let _cartInfo = response['message'];
                                if(_cartInfo !== null){
                                    window.localStorage.setItem('bixu', _cartInfo[0]?.owner?.bixu);
                                }else{
                                    window.localStorage.setItem('bixu', 0);
                                }
                    
                                });
                            } , 1000);
                            clearInterval(Interval);
                        }
                        if (response1['message'].status_queue === 0 || response1['message'].status_queue === 1) {
                            setMsg('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ giây lát!');
                            setMsgBd('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ trong giây lát');
                        } 
                        if (response1['message'].status_queue === 2 || response1['message'].status_queue === 4 || response1['message'].status_queue === 5) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng đặt không thành công! Rất xin lỗi vì sự bất tiện này, Bạn vui lòng đặt lại đơn hàng');
                        }  
                        if (response1['message'].status_queue === 3) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                        }
                    });
            }, 10000);

            setInterval(() => {
                clearInterval(Interval);
            }, 300000);

        }
        if(Object.keys(params).length > 0){
            const Interval = setInterval(() => {
                if (typeof window !== "undefined") {
                    queue(params.id, localStorage.getItem('key')).then((response1) => {
                        if (response1.status === 200) {
                            setIdcart(response1['message'].sale);
                            setId(response1['message']._id);
                            localStorage.removeItem("itemsCart");
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                            setTimeout(async () =>{
                                await getCartInfo(localStorage.getItem('key')).then((response)=>{
                                window.localStorage.setItem('cartInfo', JSON.stringify(response['message']));
                                
                                let _cartInfo = response['message'];
                                if(_cartInfo !== null){
                                    window.localStorage.setItem('bixu', _cartInfo[0]?.owner?.bixu);
                                }else{
                                    window.localStorage.setItem('bixu', 0);
                                }
                    
                                });
                            } , 1000);
                            clearInterval(Interval);
                        }
                        if (response1['message'].status_queue === 0 || response1['message'].status_queue === 1) {
                            setMsg('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ giây lát!');
                            setMsgBd('Đơn hàng của Bạn đang được tiếp tục xử lý, vui lòng chờ trong giây lát');
                        } 
                        if (response1['message'].status_queue === 2 || response1['message'].status_queue === 4 || response1['message'].status_queue === 5) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng đặt không thành công! Rất xin lỗi vì sự bất tiện này, Bạn vui lòng đặt lại đơn hàng');
                        }  
                        if (response1['message'].status_queue === 3 || response1['message'].status_queue === 11) {
                            setMsg('Cảm ơn Bạn đã mua hàng!');
                            setMsgBd('Đơn hàng của Bạn đã được tiếp nhận xử lý, vui lòng theo dõi trong quản lý đơn hàng');
                        }
                    });
                }
            }, 10000);
    
            setInterval(() => {
                clearInterval(Interval);
            }, 300000);
        }
    })
    
    const handleRedirect =(uri)=>{
        window.location.href = uri ;
    }
    const handlePayment=()=>{
        try {
                GetLinkInfor({ "orderCode": idcart}, localStorage.getItem('key')).then((respose)=>{
                    window.location.href = respose.message?.urlPayment;
                })
            } catch (error) {
                console.log(error)
            }
    }
    return (
        <Layout>
    <div id="cart-css">
            <div className="fixed bg-index">
                <div className="row bg-white mgx-0">
                    <div className="row header pdx-10 pdy-10 mgx-0">
                        <div className="col-3 pdl-20" onClick={() => handleRedirect('/')}>
                            <i className="fa-solid fa fa-chevron-left"></i>
                        </div>
                        <div className="col-6 text-center">
                            <span className="name-page">THÀNH CÔNG</span>
                        </div>
                    </div>
                </div>
                <div className="row mgt-10 mgx-0">
                    <div className="pdx-0">
                        <div className="pdx-10 pdy-12 bg-white">
                            <ul className="bs4-order-tracking-mobile ">
                                <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                <li id="delivery" className="step active"><div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giao hàng</span></li>
                                <li id="payment" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_red.png" alt="icon" /></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                <li id="complate" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_red.png" alt="icon" /></div></div><span className="text-normal-12"> Thành công </span> </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: 128 }}></div>
            <div className="bg-white" id="cart-css">
                <div className="row pdt-20 pdx-20" style={{height:10}}>
                    <span className="name-page">{msg}</span>
                </div>
                <div style={{height:20}}></div>
                <div className="row padding-box-payment">
                    <div className="row p-4" style={{background:'#F8F8F8'}} onClick={()=>handleRedirect('https://onelink.to/tf6fk5')}>
                        <div className="col-md-12 d-flex justify-content-center">
                            <div className="img-qa">
                                <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/qr-tai-ap-20240617.png" alt="qa" style={{width:100}}/>
                            </div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-center text-title-payment"> 
                            <span>TẢI ỨNG DỤNG BIBO MART</span>
                        </div>
                        <div className="col-md-12  d-flex justify-content-center text-desc-payment"> 
                            <span>Theo dõi đơn hàng nhanh chóng, thuận tiện</span>
                        </div>
                        <div className="col-md-12  d-flex justify-content-center">
                                <button className="button-payment"> <img src="static/image/download1.png" alt="dowload" /><span>Tải ngay</span> </button>
                        </div>
                    </div>
                    
                </div>

                <div className="row mgt-10 text-center">
                    <span className="text-normal-13">Mã đơn hàng: <strong>#<span className="text-bold-14">{idcart !== '' ? idcart : ''}</span></strong></span>
                </div>
                <div className="row">
                    <div className="pdx-20">
                        <div className="row pdx-20 mgx-20 pdy-10 mgy-10 bg-yellow text-center">
                            <span className="text-normal-13">{
                                isSuccess === "false" ? (fixMsg):(msgBd)
                            }</span>
                        </div>
                    </div>
                </div>
                {
                    id !== '' &&  isSuccess !== "false"? (
                        <div className="row mgt-10">
                            <div className="pdx-30">
                                <button className="btn-cancel pdy-10" onClick={() => handleRedirect('/mobile/orderdetail.html?' + id)} >CHI TIẾT ĐƠN HÀNG</button>
                            </div>
                        </div>
                    ) : (
                        null
                    )
                }
                {
                    isSuccess === "false" ? (
                        <div className="row mgt-10">
                            <div className="pdx-30">
                                <button className="btn-cancel pdy-10" onClick={() => handlePayment()} >THANH TOÁN</button>
                            </div>
                        </div>
                    ) : (
                        null
                    )
                }
                <div className="row mgt-10">
                    <div className="pdx-30">
                        <button className="btn-confirm pdy-10" onClick={() => handleRedirect('/')}>
                            TIẾP TỤC MUA HÀNG
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </Layout>
    )
}
export default Completeorder;